
import * as util from 'util'

import * as big from '../big'
import * as int64 from '../int64'
import * as uuid from '../uuid'

import * as fbe from '../fbe'
import * as core from '../core'
import * as inner from '../inner'

const Big = big.Big // eslint-disable-line
const Int64 = int64.Int64 // eslint-disable-line
const UInt64 = int64.UInt64 // eslint-disable-line
const UUID = uuid.UUID // eslint-disable-line
import {Person} from '../entity/Person';
import {FieldModelPerson} from '../entity/Person';

/**
 * PersonsInsertParams struct
 */
class PersonsInsertParams {
  /**
   * Initialize struct
   * @param {!Array=} persons
   * @constructor
   */
  constructor (persons = []) {
    this.Persons = persons
  }

  /**
   * Copy struct (shallow copy)
   * @this {!PersonsInsertParams}
   * @param {!PersonsInsertParams} other Other struct
   * @returns {!PersonsInsertParams} This struct
   */
  copy (other) {
    if (other.Persons != null) {
      this.Persons = []
      for (let item of other.Persons) {
        if (item != null) {
          let tempItem
          tempItem = Person.fromObject(item)
          this.Persons.push(tempItem)
        } else {
          this.Persons.push(null)
        }
      }
    } else {
      this.Persons = null
    }
    return this
  }

  /**
   * Clone struct (deep clone)
   * @this {!PersonsInsertParams}
   * @returns {!PersonsInsertParams} Cloned struct
   */
  clone () {
    // Serialize the struct to the FBE stream
    let writer = new PersonsInsertParamsModel(new fbe.WriteBuffer())
    writer.serialize(this)

    // Deserialize the struct from the FBE stream
    let reader = new PersonsInsertParamsModel(new fbe.ReadBuffer())
    reader.attachBuffer(writer.buffer)
    return reader.deserialize().value
  }

  /**
   * Is this struct equal to other one?
   * @this {!PersonsInsertParams}
   * @param {!PersonsInsertParams} other Other struct
   * @returns {boolean} Equal result
   */
  eq (other) {
    if (!(other instanceof PersonsInsertParams)) {
      throw new TypeError('Instance of PersonsInsertParams is required!')
    }
    return true
  }

  /**
   * Convert struct to JSON
   * @this {!PersonsInsertParams}
   * @returns {!object} Struct value for JSON
   */
  toJSON () {
    return {
      Persons: ((this.Persons != null) ? Array.from(this.Persons, item => ((item != null) ? item : null)) : null)
    }
  }

  /**
   * Convert JSON to struct
   * @param {!string} json JSON string
   * @returns {!object} Struct value for JSON
   */
  static fromJSON (json) {
    return PersonsInsertParams.fromObject(JSON.parse(json))
  }

  /**
   * Create struct from object value
   * @param {!PersonsInsertParams} other Object value
   * @returns {!PersonsInsertParams} Created struct
   */
  static fromObject (other) {
    return new PersonsInsertParams().copy(other)
  }

  /**
   * Get the FBE type
   * @this {!PersonsInsertParams}
   * @returns {!number} FBE type
   */
  get fbeType () {
    return PersonsInsertParams.fbeType
  }

  /**
   * Get the FBE type (static)
   * @this {!PersonsInsertParams}
   * @returns {!number} FBE type
   */
  static get fbeType () {
    return 4182
  }
}

export { PersonsInsertParams };

/**
 * Fast Binary Encoding PersonsInsertParams field model
 */
class FieldModelPersonsInsertParams extends fbe.FieldModel {
  /**
   * Initialize field model with the given buffer and offset
   * @param {!fbe.ReadBuffer|!fbe.WriteBuffer} buffer Buffer
   * @param {!number} offset Offset
   * @constructor
   */
  constructor (buffer, offset) {
    super(buffer, offset)
    this.Persons = new fbe.FieldModelVector(new FieldModelPerson(buffer, 4 + 4), buffer, 4 + 4)
  }

  /**
   * Get the field size
   * @this {!FieldModelPersonsInsertParams}
   * @returns {!number} Field size
   */
  get fbeSize () {
    return 4
  }

  /**
   * Get the field body size
   * @this {!FieldModelPersonsInsertParams}
   * @returns {!number} Field body size
   */
  get fbeBody () {
    return 4 + 4 + this.Persons.fbeSize
  }

  /**
   * Get the field extra size
   * @this {!FieldModelPersonsInsertParams}
   * @returns {!number} Field extra size
   */
  get fbeExtra () {
    if ((this._buffer.offset + this.fbeOffset + this.fbeSize) > this._buffer.size) {
      return 0
    }

    let fbeStructOffset = this.readUInt32(this.fbeOffset)
    if ((fbeStructOffset === 0) || ((this._buffer.offset + fbeStructOffset + 4) > this._buffer.size)) {
      return 0
    }

    this._buffer.shift(fbeStructOffset)

    let fbeResult = this.fbeBody + this.Persons.fbeExtra

    this._buffer.unshift(fbeStructOffset)

    return fbeResult
  }

  /**
   * Get the field type
   * @this {!FieldModelPersonsInsertParams}
   * @returns {!number} Field type
   */
  get fbeType () {
    return FieldModelPersonsInsertParams.fbeType
  }

  /**
   * Get the field type (static)
   * @this {!FieldModelPersonsInsertParams}
   * @returns {!number} Field type
   */
  static get fbeType () {
    return 4182
  }

  /**
   * Check if the struct value is valid
   * @this {!FieldModelPersonsInsertParams}
   * @param {!boolean} fbeVerifyType Verify model type flag, defaults is true
   * @returns {!boolean} Field model valid state
   */
  verify (fbeVerifyType = true) {
    if ((this._buffer.offset + this.fbeOffset + this.fbeSize) > this._buffer.size) {
      return true
    }

    let fbeStructOffset = this.readUInt32(this.fbeOffset)
    if ((fbeStructOffset === 0) || ((this._buffer.offset + fbeStructOffset + 4 + 4) > this._buffer.size)) {
      return false
    }

    let fbeStructSize = this.readUInt32(fbeStructOffset)
    if (fbeStructSize < (4 + 4)) {
      return false
    }

    let fbeStructType = this.readUInt32(fbeStructOffset + 4)
    if (fbeVerifyType && (fbeStructType !== this.fbeType)) {
      return false
    }

    this._buffer.shift(fbeStructOffset)
    let fbeResult = this.verifyFields(fbeStructSize)
    this._buffer.unshift(fbeStructOffset)
    return fbeResult
  }

  /**
   * Check if the struct fields are valid
   * @this {!FieldModelPersonsInsertParams}
   * @param {!number} fbeStructSize FBE struct size
   * @returns {!boolean} Field model valid state
   */
  verifyFields (fbeStructSize) {
    let fbeCurrentSize = 4 + 4

    if ((fbeCurrentSize + this.Persons.fbeSize) > fbeStructSize) {
      return true
    }
    if (!this.Persons.verify()) {
      return false
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.Persons.fbeSize

    return true
  }

  /**
   * Get the struct value (begin phase)
   * @this {!FieldModelPersonsInsertParams}
   * @returns {!number} Field model begin offset
   */
  getBegin () {
    if ((this._buffer.offset + this.fbeOffset + this.fbeSize) > this._buffer.size) {
      return 0
    }

    let fbeStructOffset = this.readUInt32(this.fbeOffset)
    console.assert((fbeStructOffset > 0) && ((this._buffer.offset + fbeStructOffset + 4 + 4) <= this._buffer.size), 'Model is broken!')
    if ((fbeStructOffset === 0) || ((this._buffer.offset + fbeStructOffset + 4 + 4) > this._buffer.size)) {
      return 0
    }

    let fbeStructSize = this.readUInt32(fbeStructOffset)
    console.assert((fbeStructSize >= (4 + 4)), 'Model is broken!')
    if (fbeStructSize < (4 + 4)) {
      return 0
    }

    this._buffer.shift(fbeStructOffset)
    return fbeStructOffset
  }

  /**
   * Get the struct value (end phase)
   * @this {!FieldModelPersonsInsertParams}
   * @param {!number} fbeBegin Field model begin offset
   */
  getEnd (fbeBegin) {
    this._buffer.unshift(fbeBegin)
  }

  /**
   * Get the struct value
   * @this {!FieldModelPersonsInsertParams}
   * @param {!PersonsInsertParams} fbeValue Default value, defaults is new PersonsInsertParams()
   * @returns {!PersonsInsertParams} PersonsInsertParams value
   */
  get (fbeValue = new PersonsInsertParams()) {
    let fbeBegin = this.getBegin()
    if (fbeBegin === 0) {
      return fbeValue
    }

    let fbeStructSize = this.readUInt32(0)
    this.getFields(fbeValue, fbeStructSize)
    this.getEnd(fbeBegin)
    return fbeValue
  }

  /**
   * Get the struct fields values
   * @this {!FieldModelPersonsInsertParams}
   * @param {!PersonsInsertParams} fbeValue PersonsInsertParams value
   * @param {!number} fbeStructSize Struct size
   */
  getFields (fbeValue, fbeStructSize) {
    let fbeCurrentSize = 4 + 4

    if ((fbeCurrentSize + this.Persons.fbeSize) <= fbeStructSize) {
      this.Persons.get(fbeValue.Persons)
    } else {
      fbeValue.Persons.length = 0
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.Persons.fbeSize
  }

  /**
   * Set the struct value (begin phase)
   * @this {!FieldModelPersonsInsertParams}
   * @returns {!number} Field model begin offset
   */
  setBegin () {
    console.assert(((this._buffer.offset + this.fbeOffset + this.fbeSize) <= this._buffer.size), 'Model is broken!')
    if ((this._buffer.offset + this.fbeOffset + this.fbeSize) > this._buffer.size) {
      return 0
    }

    let fbeStructSize = this.fbeBody
    let fbeStructOffset = this._buffer.allocate(fbeStructSize) - this._buffer.offset
    console.assert((fbeStructOffset > 0) && ((this._buffer.offset + fbeStructOffset + fbeStructSize) <= this._buffer.size), 'Model is broken!')
    if ((fbeStructOffset <= 0) || ((this._buffer.offset + fbeStructOffset + fbeStructSize) > this._buffer.size)) {
      return 0
    }

    this.writeUInt32(this.fbeOffset, fbeStructOffset)
    this.writeUInt32(fbeStructOffset, fbeStructSize)
    this.writeUInt32(fbeStructOffset + 4, this.fbeType)

    this._buffer.shift(fbeStructOffset)
    return fbeStructOffset
  }

  /**
   * Set the struct value (end phase)
   * @this {!FieldModelPersonsInsertParams}
   * @param {!number} fbeBegin Field model begin offset
   */
  setEnd (fbeBegin) {
    this._buffer.unshift(fbeBegin)
  }

  /**
   * Set the struct value
   * @this {!FieldModelPersonsInsertParams}
   * @param {!PersonsInsertParams} fbeValue PersonsInsertParams value
   */
  set (fbeValue) {
    let fbeBegin = this.setBegin()
    if (fbeBegin === 0) {
      return
    }

    this.setFields(fbeValue)
    this.setEnd(fbeBegin)
  }

  /**
   * Set the struct fields values
   * @this {!FieldModelPersonsInsertParams}
   * @param {PersonsInsertParams} fbeValue PersonsInsertParams value
   */
  setFields (fbeValue) {
    this.Persons.set(fbeValue.Persons)
  }
}

export { FieldModelPersonsInsertParams };

/**
 * Fast Binary Encoding PersonsInsertParams model
 */
class PersonsInsertParamsModel extends fbe.Model {
  /**
   * Initialize model with the given buffer
   * @param {!fbe.ReadBuffer|!fbe.WriteBuffer} buffer Read/Write buffer, defaults is new fbe.WriteBuffer()
   * @constructor
   */
  constructor (buffer = new fbe.WriteBuffer()) {
    super(buffer)
    this._model = new FieldModelPersonsInsertParams(this.buffer, 4)
  }

  /**
   * Get the PersonsInsertParams model
   * @this {!PersonsInsertParamsModel}
   * @returns {!FieldModelPersonsInsertParams} model PersonsInsertParams model
   */
  get model () {
    return this._model
  }

  /**
   * Get the model size
   * @this {!PersonsInsertParamsModel}
   * @returns {!number} Model size
   */
  get fbeSize () {
    return this.model.fbeSize + this.model.fbeExtra
  }

  /**
   * Get the model type
   * @this {!PersonsInsertParamsModel}
   * @returns {!number} Model type
   */
  get fbeType () {
    return PersonsInsertParamsModel.fbeType
  }

  /**
   * Get the model type (static)
   * @this {!PersonsInsertParamsModel}
   * @returns {!number} Model type
   */
  static get fbeType () {
    return FieldModelPersonsInsertParams.fbeType
  }

  /**
   * Check if the struct value is valid
   * @this {!PersonsInsertParamsModel}
   * @returns {!boolean} Model valid state
   */
  verify () {
    if ((this.buffer.offset + this.model.fbeOffset - 4) > this.buffer.size) {
      return false
    }

    let fbeFullSize = this.readUInt32(this.model.fbeOffset - 4)
    if (fbeFullSize < this.model.fbeSize) {
      return false
    }

    return this.model.verify()
  }

  /**
   * Create a new model (begin phase)
   * @this {!PersonsInsertParamsModel}
   * @returns {!number} Model begin offset
   */
  createBegin () {
    return this.buffer.allocate(4 + this.model.fbeSize)
  }

  /**
   * Create a new model (end phase)
   * @this {!PersonsInsertParamsModel}
   * @param {!number} fbeBegin Model begin offset
   */
  createEnd (fbeBegin) {
    let fbeEnd = this.buffer.size
    let fbeFullSize = fbeEnd - fbeBegin
    this.writeUInt32(this.model.fbeOffset - 4, fbeFullSize)
    return fbeFullSize
  }

  /**
   * Serialize the struct value
   * @this {!PersonsInsertParamsModel}
   * @param {!PersonsInsertParams} value PersonsInsertParams value
   * @return {!number} Model begin offset
   */
  serialize (value) {
    let fbeBegin = this.createBegin()
    this.model.set(value)
    return this.createEnd(fbeBegin)
  }

  /**
   * Deserialize the struct value
   * @this {!PersonsInsertParamsModel}
   * @param {!PersonsInsertParams} value PersonsInsertParams value, defaults is new PersonsInsertParams()
   * @return {!object} Deserialized PersonsInsertParams value and its size
   */
  deserialize (value = new PersonsInsertParams()) {
    if ((this.buffer.offset + this.model.fbeOffset - 4) > this.buffer.size) {
      return { value: new PersonsInsertParams(), size: 0 }
    }

    let fbeFullSize = this.readUInt32(this.model.fbeOffset - 4)
    console.assert((fbeFullSize >= this.model.fbeSize), 'Model is broken!')
    if (fbeFullSize < this.model.fbeSize) {
      return { value: new PersonsInsertParams(), size: 0 }
    }

    this.model.get(value)
    return { value: value, size: fbeFullSize }
  }

  /**
   * Move to the next struct value
   * @this {!PersonsInsertParamsModel}
   * @param {!number} prev Previous PersonsInsertParams model size
   */
  next (prev) {
    this.model.fbeShift(prev)
  }
}

export { PersonsInsertParamsModel };
